import styled from "@emotion/styled";

const Form = styled.form<{ fullWidth?: boolean }>`
  ${({ fullWidth }) => fullWidth && "width: 100%;"}
`;

export { Form };
